export enum InombraRoutes {
  Dashboard = '',
  Login = 'login',
  ResetPassword = 'password-reset',
  Clients = 'clients',
  Cart = 'cart',
  Workflow = 'workflow',
  Account = 'account',
  Workshop = 'workshop',
  Book = 'book',
  Calendar = 'calendar',
  FileManager = 'file-manager',
  FileManagerAdmin = 'file-manager-admin',
  Media = 'media',
  Task = 'task',
  Settings = 'settings',
  Gallery = 'gallery',
  File = 'file',
  Businesses = 'businesses',
  Suppliers = 'suppliers',
  Components = 'components',
  Fabrics = 'fabrics',
  Items = 'items',
  Users = 'users',
  Statuses = 'statuses',
  Profile = 'profile',
  Invoice = 'invoice',
  Notifications = 'notifications',
  Survey = 'survey',
  Systems = 'systems',
}
